import React from 'react';
import { SimovsatVehicle } from '~/types';
import { Container } from './styles';
import InfoPanel from '../MapModalSections/InfoPanel';
import NameValueItem from '../MapModalSections/NameValueItem';

interface SimovsatVehicleInfoProps {
  vehicle: SimovsatVehicle;
}

const SimovsatVehicleInfo: React.FC<SimovsatVehicleInfoProps> = ({ vehicle }) => {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return dateString;
    }
  };

  return (
    <div>
      <Container>
        <InfoPanel title='Informações do Veículo'>
          <NameValueItem title='Nome'>{vehicle.name || 'N/A'}</NameValueItem>
          <NameValueItem title='Placa'>{vehicle.plate_number || 'N/A'}</NameValueItem>
          <NameValueItem title='IMEI'>{vehicle.imei || 'N/A'}</NameValueItem>
          <NameValueItem title='Modelo do Dispositivo'>{vehicle.device_model || 'N/A'}</NameValueItem>
          <NameValueItem title='Status'>{vehicle.active ? 'Ativo' : 'Inativo'}</NameValueItem>
          <NameValueItem title='VIN'>{vehicle.vin || 'N/A'}</NameValueItem>
        </InfoPanel>

        <InfoPanel title='Localização'>
          <NameValueItem title='Latitude'>{vehicle.latitude?.toFixed(6) || 'N/A'}</NameValueItem>
          <NameValueItem title='Longitude'>{vehicle.longitude?.toFixed(6) || 'N/A'}</NameValueItem>
          <NameValueItem title='Última Posição'>{formatDate(vehicle.lastPosition)}</NameValueItem>
        </InfoPanel>

        <InfoPanel title='Informações Adicionais'>
          <NameValueItem title='ID Traccar'>{vehicle.traccar_device_id || 'N/A'}</NameValueItem>
          <NameValueItem title='ID'>{vehicle.id || 'N/A'}</NameValueItem>
          <NameValueItem title='Criado em'>{formatDate(vehicle.created_at)}</NameValueItem>
          <NameValueItem title='Atualizado em'>{formatDate(vehicle.updated_at)}</NameValueItem>
          <NameValueItem title='User ID'>{vehicle.user_id || 'N/A'}</NameValueItem>
        </InfoPanel>
      </Container>
    </div>
  );
};

export default SimovsatVehicleInfo;
